  <div class="w-full flex items-center justify-between">
    <div class="bg-[#EEFFF4] rounded-[5px] px-2 sm:px-6 py-2 flex items-center justify-center gap-x-2">
      <img class="size-6" src="/assets/images/rmportal/rupee.png" alt="rupee">
      <span class="text-[#1F8C11] text-sm font-normal">Amount Base</span>
    </div>
    <div class="flex justify-between items-center pe-3">
      <svg class="cursor-pointer" width="8" height="12" viewBox="0 0 8 12" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M3.4 6L8 10.6L6.6 12L0.6 6L6.6 0L8 1.4L3.4 6Z" fill="#C19725" />
      </svg> <span class="capitalize text-sm sm:text-base text-444 font-semibold px-1 sm:px-3">April 2025</span>
      <svg class="cursor-pointer" width="8" height="12" viewBox="0 0 8 12" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M4.6 6L0 1.4L1.4 0L7.4 6L1.4 12L0 10.6L4.6 6Z" fill="#C19725" />
      </svg>
    </div>
  </div>
  <div class="w-full px-4 py-3">
    <div class="w-full flex items-center rounded-[5px] border border-[#D9D9D9] overflow-hidden">
      <div class="w-1/3 bg-[#FFFFF6] p-2 text-center">
        <p class="text-c19725 font-semibold text-sm/tight lg:text-xl/tight">10,00,000</p>
        <span class="text-sm text-444 font-normal">Target</span>
      </div>
      <div class="w-1/3 bg-[#EEFFF4] p-2 text-center">
        <p class="text-[#1CC106] font-semibold text-sm/tight lg:text-xl/tight">2,00,000</p>
        <span class="text-sm text-444 font-normal">Complete</span>
      </div>
      <div class="w-1/3 bg-[#FFF9F9] p-2 text-center">
        <p class="text-[#BB0000] font-semibold text-sm/tight lg:text-xl/tight">8,00,000</p>
        <span class="text-sm text-444 font-normal">Pending</span>
      </div>
    </div>
  </div>
